
import React, { useState } from "react";
import { useSelector } from "react-redux";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import { Link } from "react-router-dom";
import { checkRole } from "../model";
import SearchBoxModal from "../component/SearchBoxModal";

export default function DanhSachUngVien() {
  const { user } = useSelector((state) => state.auth);
  const [company_id, setCompany_Id] = useState("");
  const myView = () => {
    const viewall = checkRole(user, 'users_new', 'viewall');
    const view_part = checkRole(user, 'users_new', 'viewdepartment');
    const view_manger = checkRole(user, 'users_new', 'view_manager');
    const view_company = checkRole(user, 'users_new', 'viewcompany');

    if (viewall) {
      return ""
    } else {
      if (view_company) {
        return "&company_id=" + user.data.company_id
      } else {
        if (view_part) {
          return "&part_id=" + user.data.part_id
        } else {
          if (view_manger) {
            return "&view=view_manager"
          } else {
            return "view=myselt"
          }
        }
      }
    }
  }

  const [params, setParam] = useState(myView());
  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState("");
  const [cccd, setCccd] = useState("");
  const [mobile, setMobile] = useState("");
  const [filterShow, setFilterShow] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    let _param = myView()
    if (fullname !== '') _param += "&fullname=" + fullname
    if (email !== '') _param += "&email=" + email
    if (cccd !== '') _param += "&cccd=" + cccd
    if (cccd !== '') _param += "&cccd=" + cccd
    if (mobile !== '') _param += "&mobile=" + mobile
    if (company_id !== '') _param += "&company_id=" + company_id
    // console.log(_param);
    setParam(_param);
  };

  let columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    { name: "fullname", label: "Họ và tên", options: { filter: true, sort: true, filterType: 'textField' } },
    { name: "sex", label: "Giới tính" },
    { name: "mobile", label: "Điện thoại", width: 150 },
    { name: "email", label: "Email", width: 250 },
    { name: "vitriungtuyen", label: "Vị trí", },
    { name: "tenphongban", label: "Phòng ban", },
    { name: "tencongty", label: "Công ty", },
    {
      name: "status", label: "Trạng thái duyệt",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value == 1 ? <span className="text-success">Đã duyệt</span> : <span className="text-danger">Chưa duyệt</span>
        },
      }
    },
    { name: "datecreate", label: "Ngày tạo" },
  ];


  return (<AkkhorLayout idrole="users_new">
    <div className="breadcrumbs-area">
      <ul>
        <li>
          <Link to="/">Trang chủ</Link>
        </li>
        <li>
          Danh sách ứng viên
        </li>
      </ul>
    </div>

    <div className="card card-filter mb-3">
      <div className="card-header">
        <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
          <div className="mr-auto">
            <h3 className="title">Tìm kiếm</h3>
          </div>
          <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
        </div>
      </div>
      <div className={filterShow ? "card-body" : 'hidden-filter'}>
        <form className="new-added-form" method="get" >
          <div className="row">
            <div className="col-lg-2 col-md-6 col-sm-6 col-12 form-group">
              <label>Tên nhân viên </label>
              <input type="text" placeholder="Tìm theo tên" value={fullname} onChange={(e) => setFullname(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6 col-12 form-group">
              <label>Email</label>
              <input type="text" placeholder="Tìm theo email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6 col-12 form-group">
              <label>CCCD</label>
              <input type="text" placeholder="Tìm theo số cccd" value={cccd} onChange={(e) => setCccd(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6 col-12 form-group">
              <label>Số điện thoại</label>
              <input type="text" placeholder="Tìm theo số số điện thoại" value={mobile} onChange={(e) => setMobile(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-sm-3 col-12 form-group">
              <label>Công ty </label>
              <SearchBoxModal apiname={"company"} placeholder="Chọn Công ty" colvalue={'id'} colname={'title'} name='company_id'
                onChange={(e) => {
                  setCompany_Id(e)
                }}></SearchBoxModal>
            </div>

            <div className="col-12 ">
              <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <SRList name="users_new" idrole="users_new" params={params} title="Ứng viên" defaultLimit={20} serverSide={true} columns={columns} >
    </SRList>
  </AkkhorLayout>);
}
